import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { FormContainer } from './containers/FormContainer';
import { trackPhoneAuthNeedHelp } from '../../utils/tracking';
import { NoticeContainer } from '../NoticeContainer';
import { HelpContainer } from '../HelpContainer';
export function PhoneAuthViewContainer() {
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null), /*#__PURE__*/React.createElement(NoticeContainer, null), /*#__PURE__*/React.createElement(FormContainer, null), /*#__PURE__*/React.createElement(HelpContainer, {
    onClick: trackPhoneAuthNeedHelp
  }));
}